import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import {
	CarrierDTOResponse,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	ProjectDTO,
	RestService,
	TruckSearchTable,
	PROJECT_CARRIER_MAP_STATUS,
} from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import {
	CAPACITY_SEARCH_FILTER,
	CARGOCHIEF_KEYS,
	RANGE_FILTERS,
} from '@domain/constants/app-variables';
import { CapacitySearchFilterService } from '@service/capacitySearchFilter/capacity-search-filter.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { environment } from '@environment/environment';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { SharedService } from '@service/shared/shared.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { ProductsService } from '@service/products/products.service';

@Component({
	selector: 'app-capacity-search-filter',
	templateUrl: './capacity-search-filter.component.html',
	styleUrls: ['./capacity-search-filter.component.scss'],
	encapsulation: ViewEncapsulation.Emulated,
})
export class CapacitySearchFilterComponent implements OnInit, OnDestroy {
	@Input() capacitySearchResults: Array<TruckSearchTable> = [];
	@Input() searchTruckForm: any = null;
	@Input() truckLaneSearchId: string = null;
	@Input() truckSearchId: string = null;
	@Input() truckSearchResultCopy: Array<TruckSearchTable> = null;
	@Input() lanePricing: any = null;
	@Input() isCityMissing: boolean = false;
	@Input() powerUnit: number = 0;

	@Input() truckSearchIds;
	@Input() emailByTruckIds = [];
	@Input() customerCarrierMatched: boolean = true;
	@Input() inCapacitySearch: boolean = true;
	@Input() inNetworkCarrierCountForSearch: number = null;
	@Input() matchedCarrierIds: Array<string> = [];
	@Input() matchedCarriers: Array<any> = [];

	@Output() filteredList: EventEmitter<Array<TruckSearchTable>> = new EventEmitter();
	@Output() noNetworkCarriersMsg: EventEmitter<string> = new EventEmitter();
	@Output() isRequestInProgress: EventEmitter<boolean> = new EventEmitter();
	@Output() isSearchRefined: EventEmitter<boolean> = new EventEmitter();
	@Output() carrierHQRemoved: EventEmitter<void> = new EventEmitter();

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;

	carrierIDs: Array<string> = null;

	RANGE_FILTERS = RANGE_FILTERS;
	currentCapacityFilter = RANGE_FILTERS.SORT.FREQUENCY;

	capacitySearchFilterForm: UntypedFormGroup;
	carriersFilterOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIERS;
	truckFilterOptions: string[] = CAPACITY_SEARCH_FILTER.TRUCKS;
	carrierHQOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIER_HQ;

	BEST_MATCH = null;
	DESTINATION_DEADHEAD = null;
	isTruckFilterInitialized: boolean = false;
	isFormInitialized: boolean = false;
	environment = environment;
	capacitySearchCompletedEvent;
	carrierHQList: Array<CarrierDTOResponse> = null;
	recentSort = false;

	GET_OPTIONS_TOOLTIP: any = {
		DISABLED: `Please contact Cargo Chief customer support to enable Booking Assistant automation`,
		ENABLED: `Email your carriers for rates`,
		NO_MATCH: `Get Options is only available when there are matching carriers in your network`,
	};

	constructor(
		private _formBuilder: UntypedFormBuilder,
		public utilService: UtilService,
		private capacitySearchFilterService: CapacitySearchFilterService,
		public cargochief: Cargochief,
		public dialog: MatDialog,
		private segmentWrapper: SegmentWrapperService,
		private urlService: UrlService,
		private restService: RestService,
		private sharedService: SharedService,
		private router: Router,
		public accountSettings: AccountSettingsService,
		public productsService: ProductsService
	) {}

	ngOnInit() {
		this.capacitySearchFilterForm = this._formBuilder.group({
			carrierSelected: 'All Carriers',
			filterSelected: 'All Capacity',
			carrierHQ: '',
		});
		this.setCarrierSelectedFilter();
		this.setTruckFilter();
		if (
			!this.utilService.isNullOrUndefined(this.truckSearchResultCopy) &&
			this.truckSearchResultCopy.length > 0
		) {
			this.setDisplayConstants();
		}

		this.setCarrierHQFilter();
		this.capacitySearchCompletedEvent = this.sharedService
			.getSearchCompletedEvent()
			.subscribe((data: any) => {
				if (
					!this.utilService.isNullOrUndefined(data) &&
					!this.utilService.isNullOrUndefined(this.truckSearchResultCopy) &&
					data
				) {
					if (this.isFormInitialized) {
						const carrierHQFilter = this.capacitySearchFilterForm.get('carrierHQ').value;
						if (carrierHQFilter.length > 0) {
							this.getCarrierHqList(carrierHQFilter);
						}
					}
				}
			});
		this.isFormInitialized = true;
		this.initialiseFilters();
		this.setCarrierIDs();
	}

	ngOnChanges(changes: SimpleChanges) {
		this.setCarrierIDs();
		if (
			this.isFormInitialized &&
			!this.utilService.isNullOrUndefined(this.truckSearchResultCopy) &&
			!this.utilService.isNullOrUndefined(changes) &&
			!this.utilService.isNullOrUndefined(changes.truckSearchResultCopy) &&
			!this.utilService.isNullOrUndefined(changes.truckSearchResultCopy.previousValue) &&
			!this.utilService.isNullOrUndefined(changes.truckSearchResultCopy.currentValue) &&
			IS_NOT_NULL_OR_UNDEFINED(changes.capacitySearchResults) &&
			!this.utilService.isNullOrUndefined(changes.capacitySearchResults.currentValue) &&
			!this.utilService.isNullOrUndefined(changes.capacitySearchResults.currentValue) &&
			(JSON.stringify(changes.truckSearchResultCopy.previousValue).length !==
				JSON.stringify(changes.truckSearchResultCopy.currentValue).length ||
				JSON.stringify(changes.capacitySearchResults.previousValue).length !=
					JSON.stringify(changes.capacitySearchResults.currentValue).length)
		) {
			this.updateCarrierHQFilter();
		}
		// In the ngOnInit the capacity search results may or may not be populated.
		// Hence checking the lane search id here to make sure after the results are populated
		// the default sort is applied.
		if (
			IS_NOT_NULL_OR_UNDEFINED(changes?.truckLaneSearchId?.currentValue) ||
			(changes?.capacitySearchResults?.currentValue !==
				changes?.capacitySearchResults?.previousValue &&
				!this.recentSort)
		) {
			this.applySort();
			this.filterSelectedCarrierWithTruckCount();
		} else {
			this.recentSort = false;
		}
	}

	updateCarrierHQFilter() {
		let result: Array<TruckSearchTable> = this.truckSearchResultCopy;
		if (!this.utilService.isNullOrUndefined(this.carrierHQList) && this.carrierHQList.length > 0) {
			result = [...this.filterByCarrierHQ()];
		}
		this.populateDistance(this.carrierHQList, this.truckSearchResultCopy);
		result = this.capacitySearchFilterService.applyFilter(
			this.capacitySearchFilterForm.get('carrierSelected').value,
			this.capacitySearchFilterForm.get('filterSelected').value,
			result,
			this.currentCapacityFilter,
			this.carrierHQList
		);
		let newResult = result.filter((searchResult) => searchResult.powerUnits >= this.powerUnit);
		this.setCarrierIDs();
		this.filteredList.emit(newResult);
		if (
			result.length == 0 &&
			this.capacitySearchFilterForm.get('carrierSelected').value ==
				CAPACITY_SEARCH_FILTER.CARRIERS[1]
		) {
			this.emitNoNetworkCarriersMsg();
		} else {
			this.noNetworkCarriersMsg.emit('');
		}
	}

	setCarrierSelectedFilter() {
		this.capacitySearchFilterForm
			.get('carrierSelected')
			.valueChanges.subscribe((carrierSelected) => {
				const previousCarrierSelected = this.cargochief.getItem(CARGOCHIEF_KEYS.CARRIER_SELECTED);
				if (
					!this.utilService.isNullOrUndefined(previousCarrierSelected) &&
					IS_NOT_EMPTY(previousCarrierSelected) &&
					JSON.parse(previousCarrierSelected) != carrierSelected
				) {
					this.fireSegmentEvent();
				}
				this.setFilter(CARGOCHIEF_KEYS.CARRIER_SELECTED, carrierSelected);
				if (
					this.isFormInitialized &&
					!this.utilService.isNullOrUndefined(this.truckSearchResultCopy)
				) {
					const filteredResult: Array<TruckSearchTable> =
						this.capacitySearchFilterService.applyFilter(
							carrierSelected,
							this.capacitySearchFilterForm.get('filterSelected').value,
							this.truckSearchResultCopy,
							this.currentCapacityFilter,
							this.carrierHQList
						);
					let newResult = filteredResult.filter(
						(searchResult) => searchResult.powerUnits >= this.powerUnit
					);
					this.filteredList.emit(newResult);
					if (filteredResult.length == 0 && carrierSelected == CAPACITY_SEARCH_FILTER.CARRIERS[1]) {
						this.emitNoNetworkCarriersMsg();
					} else {
						this.noNetworkCarriersMsg.emit('');
					}
					this.setCarrierIDs();
				}
			});
	}

	setTruckFilter() {
		this.capacitySearchFilterForm.get('filterSelected').valueChanges.subscribe((filterSelected) => {
			const previousTruckFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.TRUCK_FILTER);
			if (
				!this.utilService.isNullOrUndefined(previousTruckFilter) &&
				IS_NOT_EMPTY(previousTruckFilter) &&
				JSON.parse(previousTruckFilter) != filterSelected
			) {
				this.fireSegmentEvent();
			}
			this.setFilter(CARGOCHIEF_KEYS.TRUCK_FILTER, filterSelected);
			if (this.isFormInitialized && this.truckSearchResultCopy) {
				let newResult: Array<TruckSearchTable> = this.capacitySearchFilterService.applyFilter(
					this.capacitySearchFilterForm.get('carrierSelected').value,
					filterSelected,
					this.truckSearchResultCopy,
					this.currentCapacityFilter,
					this.carrierHQList
				);
				if (IS_NOT_NULL_OR_UNDEFINED(this.powerUnit)) {
					newResult = newResult.filter((searchResult) => searchResult.powerUnits >= this.powerUnit);
				}
				this.filteredList.emit(newResult);
				this.setCarrierIDs();
			}
		});
	}

	setCarrierHQFilter() {
		this.capacitySearchFilterForm.get('carrierHQ').valueChanges.subscribe((filterSelected) => {
			const previousTruckFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.CARRIER_HQ_FILTER);
			if (
				!this.utilService.isNullOrUndefined(previousTruckFilter) &&
				IS_NOT_EMPTY(previousTruckFilter) &&
				JSON.parse(previousTruckFilter) != filterSelected
			) {
				this.fireSegmentEvent();
			}
			this.setFilter(CARGOCHIEF_KEYS.CARRIER_HQ_FILTER, filterSelected);
			this.setFilter(CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT, '');
			if (this.isFormInitialized && filterSelected.length > 0) {
				this.currentCapacityFilter = RANGE_FILTERS.SORT.DISTANCE_FROM_HQ;
				this.getCarrierHqList(filterSelected);
			} else {
				this.currentCapacityFilter = RANGE_FILTERS.SORT.MATCH;
				this.setFilter(CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT, this.currentCapacityFilter);
				this.clearDistance(this.truckSearchResultCopy);
				this.carrierHQRemoved.emit();
			}
		});
	}

	getCarrierHqList(filterSelected: string) {
		if (this.utilService.isNullOrUndefined(this.carrierIDs)) {
			this.setCarrierIDs();
		}
		if (!this.utilService.isNullOrUndefined(this.carrierIDs) && this.carrierIDs.length > 0) {
			this.isRequestInProgress.emit(true);
			const DHO = this.cargochief.getItem(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER),
				DHD = this.cargochief.getItem(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER);
			let latitude, longitude, maxRadius;
			if (filterSelected == CAPACITY_SEARCH_FILTER.CARRIER_HQ[0]) {
				latitude = this.searchTruckForm.origin.latitude;
				longitude = this.searchTruckForm.origin.longitude;
				if (!this.utilService.isNullOrUndefined(DHO)) {
					maxRadius = JSON.parse(DHO);
				} else {
					maxRadius = this.accountSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT;
				}
			} else {
				latitude = this.searchTruckForm.destination.latitude;
				longitude = this.searchTruckForm.destination.longitude;
				if (!this.utilService.isNullOrUndefined(DHD)) {
					maxRadius = JSON.parse(DHD);
				} else {
					maxRadius = this.accountSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT;
				}
			}
			const payload = {
				carrierIds: this.carrierIDs.join(','),
				latitude: latitude,
				longitude: longitude,
				maxRadius: maxRadius,
			};
			const url = this.urlService.searchCarrierHQ(0, environment.NO_OF_SEARCH_RESULTS_TO_DISPLAY);
			this.restService.POST(url, payload).subscribe(
				(response) => {
					this.carrierHQList = response.data;
					if (this.carrierHQList.length == 0) {
						this.filteredList.emit([]);
					} else if (this.carrierHQList.length > 0) {
						this.updateCarrierHQFilter();
					}
					this.inNetworkCarrierCountForSearch = this.carrierHQList.filter(
						(res) => res.customerCarrier
					).length;
					this.matchedCarriers = this.carrierHQList.filter((res) => res.customerCarrier);
					this.matchedCarrierIds = this.matchedCarriers.map((carrier) => carrier.id);
					this.isRequestInProgress.emit(false);
					this.setCarrierIDs();
				},
				(error) => {
					this.utilService.showSnackbar(
						'Unable to filter results by Carrier HQ.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
					this.capacitySearchFilterForm.get('carrierHQ').setValue('');
					this.filteredList.emit(this.truckSearchResultCopy);
					this.isRequestInProgress.emit(false);
				}
			);
		}
	}

	filterByCarrierHQ(): Array<TruckSearchTable> {
		let result: Array<TruckSearchTable> = [];
		if (!this.utilService.isNullOrUndefined(this.carrierHQList) && this.carrierHQList.length > 0) {
			this.carrierHQList.map((carrier) => {
				const search: TruckSearchTable = this.truckSearchResultCopy.filter((csearch) => {
					return csearch.carrierId == carrier.id;
				})[0];
				if (!this.utilService.isNullOrUndefined(search)) {
					result.push(search);
				}
			});
		}
		return result;
	}

	setDisplayConstants() {
		this.DESTINATION_DEADHEAD = this.capacitySearchFilterService.getMinDHD(
			this.truckSearchResultCopy
		);
		this.BEST_MATCH = this.capacitySearchFilterService.getMaxMatch(this.truckSearchResultCopy);
	}

	isFilterSelected(): boolean {
		return IS_NOT_EMPTY(this.capacitySearchFilterForm.get('filterSelected').value);
	}

	setFilter(filter: string, value: string) {
		this.cargochief.setItem({ [filter]: value });
	}

	initialiseFilters() {
		const carrierSelected = this.cargochief.getItem(CARGOCHIEF_KEYS.CARRIER_SELECTED),
			truckFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.TRUCK_FILTER),
			carrierHQFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.CARRIER_HQ_FILTER);
		if (!this.utilService.isNullOrUndefined(carrierSelected) && IS_NOT_EMPTY(carrierSelected)) {
			this.capacitySearchFilterForm
				.get(CARGOCHIEF_KEYS.CARRIER_SELECTED)
				.setValue(JSON.parse(carrierSelected));
		}
		if (!this.utilService.isNullOrUndefined(truckFilter) && IS_NOT_EMPTY(truckFilter)) {
			this.capacitySearchFilterForm
				.get(CARGOCHIEF_KEYS.TRUCK_FILTER)
				.setValue(JSON.parse(truckFilter));
		}
		if (!this.utilService.isNullOrUndefined(carrierHQFilter) && IS_NOT_EMPTY(carrierHQFilter)) {
			this.capacitySearchFilterForm
				.get(CARGOCHIEF_KEYS.CARRIER_HQ_FILTER)
				.setValue(JSON.parse(carrierHQFilter));
		}
	}

	applySort() {
		this.recentSort = true;
		const capacitySort = this.cargochief.getItem(CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT);
		if (IS_NOT_EMPTY(capacitySort)) {
			const filterType = JSON.parse(capacitySort);
			if (filterType == RANGE_FILTERS.SORT.FREQUENCY) {
				this.currentCapacityFilter = RANGE_FILTERS.SORT.FREQUENCY;
				this.sortSearchList(RANGE_FILTERS.SORT.FREQUENCY, false);
			} else if (filterType == RANGE_FILTERS.SORT.MATCH) {
				this.currentCapacityFilter = RANGE_FILTERS.SORT.MATCH;
				this.sortSearchList(RANGE_FILTERS.SORT.MATCH, false);
			}
		} else if (
			!this.utilService.isNullOrUndefined(this.currentCapacityFilter) &&
			this.currentCapacityFilter == RANGE_FILTERS.SORT.FREQUENCY
		) {
			this.cargochief.setItem({
				[CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT]: RANGE_FILTERS.SORT.FREQUENCY,
			});
			this.sortSearchList(RANGE_FILTERS.SORT.FREQUENCY, false);
		}
	}

	sortSearchList(sortColumn: string, fireSegmentEvent: boolean = true) {
		if (
			(sortColumn == RANGE_FILTERS.SORT.FREQUENCY || sortColumn == RANGE_FILTERS.SORT.MATCH) &&
			this.currentCapacityFilter == CARGOCHIEF_KEYS.TRUCK_FILTER
		) {
			this.capacitySearchResults = [...this.truckSearchResultCopy];
		}
		this.cargochief.setItem({ [CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT]: sortColumn });
		this.currentCapacityFilter = sortColumn;
		this.filteredList.emit(
			this.capacitySearchFilterService.sortByColumn(
				this.currentCapacityFilter,
				this.capacitySearchResults
			)
		);
		if (fireSegmentEvent) {
			this.fireSegmentEvent();
		}
		this.setCarrierIDs();
	}

	getStyle(sortColumn: string): any {
		if (this.currentCapacityFilter == sortColumn) {
			return { 'text-decoration': 'underline', cursor: 'initial' };
		} else {
			return { 'text-decoration': 'none', cursor: 'pointer' };
		}
	}

	fireSegmentEvent() {
		const payload = {
			filterType: this.currentCapacityFilter,
			carriersDropdownOptionSelected: this.capacitySearchFilterForm.get('carrierSelected').value,
		};
		this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.user_filtered_search, payload);
	}

	setCarrierIDs() {
		if (IS_NULL_OR_UNDEFINED(this.truckSearchResultCopy)) {
			this.carrierIDs = [];
			return;
		}
		this.carrierIDs = this.truckSearchResultCopy.map(({ carrierId }) => carrierId);
	}

	ngOnDestroy() {
		if (!this.utilService.isNullOrUndefined(this.capacitySearchCompletedEvent)) {
			this.capacitySearchCompletedEvent.unsubscribe();
		}
	}

	emitNoNetworkCarriersMsg() {
		this.noNetworkCarriersMsg.emit(`<p>We Didn't find any matching network carriers for this lane.
			We do have ${this.truckSearchResultCopy.length} matches.</p>
		<p>Please change your carrier filters to view the matches.</p>`);
	}

	populateDistance(
		carrierHQList: Array<CarrierDTOResponse>,
		truckSearchResult: Array<TruckSearchTable>
	): void {
		if (!this.utilService.isNullOrUndefined(carrierHQList) && carrierHQList.length > 0) {
			carrierHQList.map((carrier) => {
				const search: TruckSearchTable = truckSearchResult.find((csearch) => {
					return csearch.carrierId == carrier.id;
				});
				if (!this.utilService.isNullOrUndefined(search)) {
					search.distance = Math.round(carrier.distance);
				}
			});
		}
	}

	clearDistance(truckSearchResult: Array<TruckSearchTable>) {
		truckSearchResult?.forEach((search) => (search.distance = null));
	}

	getOptionsTooltip(): string {
		if (
			!(
				this.productsService.BOOKING_ASSISTANT &&
				(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
			)
		) {
			return this.GET_OPTIONS_TOOLTIP.DISABLED;
		}
		if (this.emailByTruckIds?.length === 0) {
			return this.GET_OPTIONS_TOOLTIP.NO_MATCH;
		}
		return this.GET_OPTIONS_TOOLTIP.ENABLED;
	}

	isGetOptionsDisabled(): boolean {
		return (
			!(
				this.productsService.BOOKING_ASSISTANT &&
				(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
			) || this.emailByTruckIds?.length === 0
		);
	}

	getSearchRefined(isSearchRefined: boolean) {
		this.isSearchRefined.emit(isSearchRefined);
	}

	filterSelectedCarrierWithTruckCount() {
		let carrierSelected = this.capacitySearchFilterForm?.get('carrierSelected')?.value;
		if (this.isFormInitialized && !this.utilService.isNullOrUndefined(this.truckSearchResultCopy)) {
			const filteredResult: Array<TruckSearchTable> = this.capacitySearchFilterService.applyFilter(
				carrierSelected,
				this.capacitySearchFilterForm.get('filterSelected').value,
				this.truckSearchResultCopy,
				this.currentCapacityFilter,
				this.carrierHQList
			);
			let newResult = filteredResult.filter(
				(searchResult) => searchResult.powerUnits >= this.powerUnit
			);
			let carrierHq = localStorage.getItem('carrierHQ');
			if (
				IS_NOT_EMPTY(carrierHq) &&
				carrierHq != `""` &&
				IS_NOT_NULL_OR_UNDEFINED(this.carrierHQList)
			) {
				newResult = newResult.filter((searchResult) =>
					this.carrierHQList.find((carrier) => carrier.id === searchResult.carrierId)
				);
			}
			this.filteredList.emit(newResult);
			if (filteredResult.length == 0 && carrierSelected == CAPACITY_SEARCH_FILTER.CARRIERS[1]) {
				this.emitNoNetworkCarriersMsg();
			} else {
				this.noNetworkCarriersMsg.emit('');
			}
			this.setCarrierIDs();
		}
	}

	isBaEnabled(): boolean {
		const isBAEnabled: boolean =
			this.productsService.BOOKING_ASSISTANT &&
			(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper()) &&
			this.accountSettings.BOOKING_ASSISTANT;
		if (isBAEnabled) {
			return this.accountSettings.GET_OPTION_VISIBLE;
		}
		return isBAEnabled;
	}
}
